<script>

    import { toast } from 'bulma-toast'

    import StatisticsService from '../$services/statistics.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import StatsCard from '../$components/stats.card.svelte'
    import Spinner from '../$components/spinner.svelte'

    export let dateStart = null
    export let dateEnd = null

    let loading = false
    let providers = []

    $: if (dateStart && dateEnd)
        getProvidersTop()

    async function getProvidersTop() {
        loading = true
        providers = []

        const resp = await StatisticsService.getShipmentsProvidersTop({
            dateStart: dateStart.toISOString(),
            dateEnd: dateEnd.toISOString(),
        })

        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        providers = resp.data?.providers ?? []
    }

</script>

<style>
    .providers-list {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
    }

    .providers-list__item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.85rem 0;
        border-bottom: 1px solid #eee;
    }

    .providers-list__item:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .providers-list__item:first-child {
        padding-top: 0;
    }

    .providers-list__rank {
        flex-shrink: 0;
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 50%;
        background: #f4f4f4;
        color: #666;
        font-size: 12px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .providers-list__info {
        flex: 1;
        min-width: 0;
    }

    .providers-list__title {
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0 0 2px;
    }

    .providers-list__meta {
        font-size: 12px;
        color: #a0a0a0;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .providers-list__total {
        flex-shrink: 0;
        font-size: 15px;
        font-weight: 700;
        color: var(--color-primary, #098E37);
    }
</style>

<StatsCard icon="fa-truck" meta="Envíos" title="Top proveedores" {dateStart} {dateEnd}>
    <div>
        <Spinner {loading} />
        {#if !loading && providers.length}
            <ul class="providers-list">
                {#each providers as provider, index}
                    <li class="providers-list__item">
                        <span class="providers-list__rank">{ index + 1 }</span>
                        <div class="providers-list__info">
                            <p class="providers-list__title">{ provider.provider } · { provider.service }</p>
                            <p class="providers-list__meta">
                                {#if provider.partner}
                                    Partner: { provider.partner }
                                {:else}
                                    { provider.provider }
                                {/if}
                            </p>
                        </div>
                        <span class="providers-list__total">{ NumeralMethods.number(provider.total) } envíos</span>
                    </li>
                {/each}
            </ul>
        {:else if !loading}
            <p class="empty">Sin datos en el periodo seleccionado</p>
        {/if}
    </div>
</StatsCard>
